import { CR_SUBMISSION } from '../../../constants';

export type SetStarRatingHintInvalidParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
};
export const setStarRatingHintInvalid = ({ rootElement }: SetStarRatingHintInvalidParams) => {
    const starRatingHint = rootElement.querySelector<HTMLSpanElement>(CR_SUBMISSION.STAR_RATING.HINT_SELECTOR);
    if (starRatingHint === null) return;
    starRatingHint.classList.add(CR_SUBMISSION.STAR_RATING.HINT_INVALID_CLASS);
};
